import { render, staticRenderFns } from "./customerView.vue?vue&type=template&id=d1b87f06&scoped=true"
import script from "./customerView.vue?vue&type=script&lang=js"
export * from "./customerView.vue?vue&type=script&lang=js"
import style0 from "./customerView.vue?vue&type=style&index=0&id=d1b87f06&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b87f06",
  null
  
)

export default component.exports